import ModifyReturnWidgetContainer from './ModifyReturnWidgetContainer';

const ModifyReturnWidget = ModifyReturnWidgetContainer;

export default ModifyReturnWidget;
